import { render, staticRenderFns } from "./ImageCreate.vue?vue&type=template&id=5afb0ac8&scoped=true&"
import script from "./ImageCreate.vue?vue&type=script&lang=js&"
export * from "./ImageCreate.vue?vue&type=script&lang=js&"
import style0 from "./ImageCreate.vue?vue&type=style&index=0&id=5afb0ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb0ac8",
  null
  
)

export default component.exports